import { render, staticRenderFns } from "./StartupAcompanhamento.vue?vue&type=template&id=8d700744"
import script from "./StartupAcompanhamento.vue?vue&type=script&lang=js"
export * from "./StartupAcompanhamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports